import { render } from "./MAGraphPanel.vue?vue&type=template&id=3809e7cc&scoped=true"
import script from "./MAGraphPanel.vue?vue&type=script&lang=ts"
export * from "./MAGraphPanel.vue?vue&type=script&lang=ts"

import "./MAGraphPanel.vue?vue&type=style&index=0&id=3809e7cc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3809e7cc"

export default script